import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff, User, Mail, Key } from "lucide-react";

interface PasswordAuthFormProps {
  isLogin: boolean;
  isLoading: boolean;
  onSubmit: (formData: {
    name?: string;
    email: string;
    password: string;
  }) => Promise<void>;
  onForgotPassword: (email: string) => Promise<void>;
}

export const PasswordAuthForm = ({
  isLogin,
  isLoading,
  onSubmit,
  onForgotPassword,
}: PasswordAuthFormProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit({ name, email, password });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {!isLogin && (
        <div className="space-y-2">
          <div className="relative">
            <Input
              type="text"
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required={!isLogin}
              className="bg-muted pl-10"
            />
            <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
          </div>
        </div>
      )}
      <div className="space-y-2">
        <div className="relative">
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-muted pl-10"
          />
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
        </div>
      </div>
      <div className="space-y-2 relative">
        <div className="relative">
          <Input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="bg-muted pl-10 pr-10"
          />
          <Key className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300"
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        </div>
        {isLogin && (
          <button
            type="button"
            onClick={() => onForgotPassword(email)}
            className="text-sm text-primary hover:underline float-right"
          >
            Forgot Password?
          </button>
        )}
      </div>
      <Button 
        type="submit" 
        className="w-full bg-primary hover:bg-primary/90"
        disabled={isLoading}
      >
        {isLoading ? "Loading..." : (isLogin ? "Sign In" : "Sign Up")}
      </Button>
    </form>
  );
};